<template>
	<v-container class="routerViewLight">
		<v-row align="center" justify="center">
			<v-col cols="6">
				<v-form @submit.prevent="onSubmit" class="auth-class mb-5 px-5 py-5">
					<v-text-field
						id="placeName-input"
						v-model.trim="loginData.placeName"
						label="Nombre del lugar"
						name="placeName"
						dense
						filled
						outlined
						type="text"
						required
					/>
					<v-text-field
						id="email-input"
						v-model.trim="loginData.email"
						label="Correo"
						name="correo"
						dense
						filled
						outlined
						type="text"
						required
					/>
					<v-text-field
						id="password-input"
						v-model.trim="loginData.password"
						label="Contraseña"
						name="password"
						prepend-icon="mdi-lock"
						dense
						filled
						outlined
						type="password"
						required
						@click:append="showPassword = !showPassword"
					/>
					<v-btn
						block
						:disabled="!(loginData.placeName && loginData.email)"
						rounded
						small
						color="primary"
						type="submit"
						data-cy="loginButton"
					>
						Ingresar
					</v-btn>
				</v-form>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="2">
				<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							solo
							class="my-2"
							clearable
							dense
							outlined
							filled
							label="Seleccione un mes"
							readonly
							v-bind="attrs"
							v-on="on"
							@click:clear="month = null"
							hide-details
							:value="dateFormatted"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="month"
						@change="menu = false"
						no-title
						type="month"
						locale="es"
					></v-date-picker>
				</v-menu>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="2">
				<v-text-field
					solo
					class="my-2"
					dense
					hide-details
					label="Nombres o fechas"
					outlined
					filled
					append-icon="mdi-magnify"
					single-line
					v-model="search"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="overflow-x-auto assitence-history">
				<v-data-table
					:headers="headers"
					:items="items"
					item-key="_id"
					:items-per-page="itemsPerPage"
					class="elevation-1 backgroundTransparent"
					no-data-text="Sin registros de asistencia"
					:footer-props="{
						'items-per-page-text': 'Registros por página',
					}"
					mobile-breakpoint="0"
				>
					<!-- fullname/nombre -->
					<template v-slot:[`item.fullName`]="{ item }">
						<div class="row-td-block text-capitalize">
							{{ item.person.firstName }} {{ item.person.lastName }}
						</div>
					</template>
					<!-- date/fecha -->
					<template v-slot:[`item.date`]="{ item }">
						<div class="row-td-block ">
							{{ dateTime(item) }}
						</div>
					</template>
					<!-- in/Ingreso -->
					<template v-slot:[`item.in`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">
							{{ formatDate(item.in) }}
						</div>
						<div class="row-td-block " v-else>-</div>
					</template>
					<!-- in/temperature -->
					<template v-slot:[`item.temperature`]="{ item }">
						<div class="row-td-block " v-if="item.temperature">
							{{ item.temperature }}
						</div>
						<div class="row-td-block " v-else>S/R</div>
					</template>
					<template v-slot:[`item.group`]="{ item }">
						<div class="row-td-block " v-if="item.group">{{ item.group }}</div>
						<div class="row-td-block " v-else>S/R</div>
					</template>
					<!-- image/foto -->
					<template v-slot:[`item.image`]="{ item }">
						<div v-if="item.image" class="row-td-block ">
							<a class="text-capitalize" :href="item.image" target="_blank">
								Ver foto
							</a>
						</div>
						<div class="row-td-block " v-else>Sin foto</div>
					</template>
					<!-- out/salida -->
					<template v-slot:[`item.out`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">
							{{ formatDate(item.out) }}
						</div>
						<div class="row-td-block " v-else>-</div>
					</template>
					<!-- extra/horas extra -->
					<template v-slot:[`item.extra`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">{{ item.extra }}</div>
						<div class="row-td-block " v-else>-</div>
					</template>
					<!-- delay/horas de retraso -->
					<template v-slot:[`item.delay`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">{{ item.delay }}</div>
					</template>
					<!-- durations/duracion entre la entrada y salida -->
					<template v-slot:[`item.durations`]="{ item }">
						<div class="row-td-block " v-if="!item.worked">
							{{ durations(item.in, item.out) }}
						</div>
					</template>
					<!-- total earned/total ganado durante ese dia -->
					<template v-slot:[`item.earned`]="{ item }">
						<template v-if="item.earned">
							<div class="row-td-block ">{{ item.earned.toFixed(2) }}</div>
							<div class="row-td-block success--text">$</div>
						</template>
						<div class="row-td-block" v-else>-</div>
					</template>
					<!-- ubications -->
					<template v-slot:[`item.actions`]="{ item }">
						<div class="row-td-block" v-if="item.worked">Sin ubicaciones</div>
						<div class="row-td-block" v-else>
							<v-btn
								class="m-0 mr-2"
								color="info"
								x-small
								@click="setMap(item.checkIn)"
							>
								<v-icon small left>mdi-map-marker-check</v-icon>
								<div class="row-td-block" v-if="!isMobile">Ingreso</div>
							</v-btn>
							<v-btn
								color="info"
								x-small
								class="m-0 mr-2"
								:disabled="formatDate(item.out) == '-'"
								@click="setMap(item.checkOut)"
							>
								<v-icon small left>mdi-map-marker-check</v-icon>
								<div class="row-td-block" v-if="!isMobile">Salida</div>
							</v-btn>
						</div>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
	name: 'Assistance',
	data() {
		return {
			loginData: {
				placeName: '',
				password: '',
				email: '',
			},
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
			search: '',
			lodgings: [],
			headers: [
				{ text: 'Fecha', value: 'date', sortable: true },
				{ text: 'Grupo/Periodo', value: 'group', sortable: true },
				{ text: 'Nombre', value: 'fullName', align: 'start', sortable: false },
				{ text: 'Ingreso', value: 'in', sortable: true },
				{ text: 'Temp.', value: 'temperature', sortable: true },
				{ text: 'Foto', value: 'image', sortable: false },
				{ text: 'Salida', value: 'out', sortable: false },
				{ text: 'Horas extra', value: 'extra', sortable: false },
				{ text: 'Horas faltantes', value: 'delay', sortable: false },
				{ text: 'Duración', value: 'durations', sortable: false },
				{ text: 'Ganado', value: 'earned', sortable: false },
				{ text: 'Ubicación', value: 'actions', align: 'end', sortable: false },
			],
			itemsPerPage: 30,
		};
	},
	computed: {
		items() {
			let endDate = moment(this.month);
			let histories = [];
			this.lodgings.forEach(lod => {
				if (lod.histories.length)
					lod.histories.map(history => {
						const historyDate = moment(history.in);
						if (historyDate.isSame(endDate, 'month')) {
							histories.push({
								...history,
								place: lod.place.name,
								room: lod.room,
								group: lod.group,
								person: lod.person,
							});
						}
					});
			});
			histories = histories.sort((a, b) => {
				const da = new Date(a.in).getTime();
				const db = new Date(b.in).getTime();
				return db < da ? -1 : db > da ? 1 : 0;
			});
			if (this.search) {
				const personAssitenceFilter = histories.filter(item => {
					let date = moment(item.in).format('DD-MM-YYYY');
					return (
						item.person.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >
							-1 ||
						item.person.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >
							-1 ||
						date.toLowerCase().indexOf(this.search.toLowerCase()) > -1
					);
				});
				return personAssitenceFilter;
			}
			return histories;
		},
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
	},
	methods: {
		async onSubmit() {
			this.loading = !this.loading;
			const data = await this.getPublicAssistance(this.loginData);
			this.lodgings = data.lodgings;
			this.loading = false;
		},
		durations(start, end) {
			if (end) {
				const diff = moment(end).diff(moment(start));
				return moment.utc(diff).format('HH:mm:ss');
			}
			return '-';
		},
		dateTime(item) {
			return moment(item.in).format('DD-MM-YYYY');
		},
		formatDate(date) {
			if (date) return moment(date).format('LT');
			else return '-';
		},
		...mapActions({
			getPublicAssistance: 'User/getPublicAssistance',
		}),
	},
};
</script>

<style scoped>
.routerViewLight {
	background-color: #ffffffad;
	padding-bottom: 20px;
}
.routerViewDark {
	background-color: #000000ad;
	padding-bottom: 20px;
}
</style>
